import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const FullPage = ({ slot }) => {
	const { type, data, layout } = slot[0];

	return (
		<Layout>
			<Slot
				top={0}
				left={0}
				width={100}
				height={100}
				component={type}
				data={data}
				layout={layout}
			/>
		</Layout>
	)
}

FullPage.defaultProps = {
	slot: []
}

FullPage.propTypes = {
	slot: PropTypes.array,
}

export default FullPage
